export const apiUrl = 'https://api.tacom.srv.br/';
export const praca = 'sca';
export const apiLoginUrl = 'https://apigw.tacom.srv.br/authentication/v1/auth2/login';
export const username = 'sca-citsoa@tacom.com.br';
export const password = 'ujmV(61tLN';

export const versaoSoftware = '4.4.16';
export const idioma = 'pt_BR'

export default {
}
